const CART_KEY = "bmj_booking_cart";
const NEXT_KEY = "bmj_auth_next";
const DRAFT_KEY = "bmj_booking_draft";

export function readBookingCart() {
  try {
    const raw = JSON.parse(localStorage.getItem(CART_KEY) || "[]");
    return Array.isArray(raw) ? raw.filter((s) => s && s.id) : [];
  } catch {
    return [];
  }
}

export function writeBookingCart(items) {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(items || []));
  } catch {
    /* ignore quota */
  }
}

export function clearBookingCart() {
  try {
    localStorage.removeItem(CART_KEY);
    sessionStorage.removeItem(DRAFT_KEY);
    localStorage.removeItem(DRAFT_KEY);
  } catch {
    /* ignore */
  }
}

export function mergeBookingCart(item) {
  if (!item?.id) return readBookingCart();
  const cart = readBookingCart();
  const existing = cart.find((s) => s.id === item.id);
  if (existing) {
    const qty = item.qty != null ? Math.max(1, Number(item.qty) || 1) : Math.max(1, Number(existing.qty) || 1);
    writeBookingCart(cart.map((s) => (s.id === item.id ? { ...s, ...item, name: item.name || s.name, qty } : s)));
  } else {
    writeBookingCart([...cart, { ...item, qty: Math.max(1, Number(item.qty) || 1) }]);
  }
  return readBookingCart();
}

export function cartQty(itemId) {
  const row = readBookingCart().find((s) => s.id === itemId);
  return Math.max(0, Number(row?.qty) || 0);
}

export function setCartQty(item, qty) {
  if (!item?.id) return readBookingCart();
  const n = Math.max(0, Number(qty) || 0);
  const cart = readBookingCart();
  if (n <= 0) {
    writeBookingCart(cart.filter((s) => s.id !== item.id));
    return readBookingCart();
  }
  if (cart.some((s) => s.id === item.id)) {
    writeBookingCart(cart.map((s) => (s.id === item.id ? { ...s, ...item, qty: n } : s)));
  } else {
    writeBookingCart([...cart, { ...item, qty: n }]);
  }
  return readBookingCart();
}

export function expandCartLines() {
  return readBookingCart().flatMap((s) => {
    const qty = Math.max(1, Number(s.qty) || 1);
    const serviceId = s.service_id || String(s.id || "").split("::")[0];
    return Array.from({ length: qty }, (_, i) => ({
      key: `${s.id}-${i}`,
      service_id: serviceId,
      brand_id: s.brand_id || "",
      brand_name: s.brand_name || "",
      name: s.name,
      category: s.category,
      indicative_price: s.indicative_price,
      qtyIndex: i + 1,
      qtyTotal: qty,
    }));
  });
}

export function cartAppointmentCount() {
  return readBookingCart().reduce((n, s) => n + Math.max(1, Number(s.qty) || 1), 0);
}

export function readWizardDraft() {
  try {
    const raw = JSON.parse(sessionStorage.getItem(DRAFT_KEY) || localStorage.getItem(DRAFT_KEY) || "null");
    return raw && typeof raw === "object" ? raw : null;
  } catch {
    return null;
  }
}

export function writeWizardDraft(draft) {
  const payload = JSON.stringify(draft || {});
  try {
    sessionStorage.setItem(DRAFT_KEY, payload);
  } catch {
    /* ignore */
  }
  try {
    localStorage.setItem(DRAFT_KEY, payload);
  } catch {
    /* ignore */
  }
}

export function setAuthNext(path) {
  try {
    if (path) sessionStorage.setItem(NEXT_KEY, path);
    else sessionStorage.removeItem(NEXT_KEY);
  } catch {
    /* ignore */
  }
}

export function consumeAuthNext() {
  try {
    const v = sessionStorage.getItem(NEXT_KEY) || "";
    sessionStorage.removeItem(NEXT_KEY);
    return v;
  } catch {
    return "";
  }
}
